import { ROUTES } from "constants/index";
import { useEffect } from "react";
import { useRouter } from "next/compat/router";
import { useIsV2InApp } from "./useIsV2InApp";
import { closeWebview } from "../utils/nativeBridgeHelper";

interface BackHandlerConfig {
    [key: string]: () => boolean;
}

// Define back navigation behavior
const getBackHandlerConfig = (router: ReturnType<typeof useRouter>, isV2InApp: boolean): BackHandlerConfig => ({
    TRACK: () => {
        router?.replace(ROUTES.MENU); // Use replace to prevent history stack issues
        return true;
    },
    MENU: () => {
        // do nothing
        return true;
    },
    COLLECTIONS: () => {
        router?.replace(ROUTES.MENU);
        return true;
    },
    BILL_SUMMARY: () => {
        if (isV2InApp) {
            closeWebview();
        } else {
            router?.replace(ROUTES.MENU);
        }
        return true;
    },
    BACK: () => {
        router?.back();
        return true;
    },
    CART_ORDERS: () => {
        if (isV2InApp) {
            closeWebview();
        } else {
            router?.back();
        }
        return true;
    },
    PAYMENT: () => {
        router?.replace(ROUTES.BILL_SUMMARY);
        return true;
    },
});

export const useHardwareBackHandler = (currentPage: string): void => {
    const router = useRouter();
    const { isV2InApp } = useIsV2InApp();

    useEffect(() => {
        const handleBackPress = (event: PopStateEvent): void => {
            const handler = getBackHandlerConfig(router, isV2InApp)[currentPage];
            if (handler) {
                const shouldPreventDefault = handler();
                if (shouldPreventDefault) {
                    event.preventDefault();
                    window.history.pushState(null, "", window.location.href); // Keeps the user on the same page
                }
            }
        };

        // Push initial state to prevent default browser back behavior
        window.history.pushState(null, "", window.location.href);
        window.addEventListener("popstate", handleBackPress);

        return () => {
            window.removeEventListener("popstate", handleBackPress);
        };
    }, [currentPage, router, isV2InApp]);
};
